import { toInteger } from 'lodash';
import * as yup from 'yup';

export const convertToInteger = (currItem: string) => {
  if (currItem) {
    return toInteger(currItem);
  }
  return null;
};

export const pwdStrategySchema = yup.object({
  password_min_length: yup.number(),
  password_min_digits: yup.number(),
  password_min_chars: yup.number(),
  password_min_symbols: yup.number(),
  password_max_retry: yup.number(),
  password_validity: yup.number().nullable(),
  password_unique: yup.boolean()
});

export const SSOSettingsSchema = yup.object({
  'saml_idp_use-identity': yup.boolean(),
  'identity_use-oidc': yup.boolean(),
  account_edit_accountName_disable: yup.boolean(),
  account_edit_comEmail_disable: yup.boolean(),
  'identity-disable-local-login': yup.boolean()
});

export const generalSchema = yup.object({
  single_sign_on: yup.boolean(),
  case_sensitive_login: yup.boolean(),
  account_synchronisation_email: yup.boolean()
});
